angular.module('impactx.electronicdownload').controller('ElectronicDownloadAdminCtrl', [
    '$scope',
    'selectedListItems',
    'dataGen',
    'ListHelperService',
    'ToastService',
    '$mdDialog',
    'ConfirmationService',
    'TranslationService',
    ElectronicDownloadAdminController]);

function ElectronicDownloadAdminController($scope, selectedListItems, dataGen, ListHelperService, ToastService, $mdDialog, ConfirmationService, TranslationService) {
    var self = this;

    self.resetDownloadCounter = function (event, trns) {
        dataGen.postAsForm({}, {eddId: selectedListItems.getFirstSelectedId()}, '/electronicdownload/reset').then(function () {
            ToastService.openStandardToast(trns.resetSuccess);
            refreshList();
        });
    };

    self.showAccessLog = function (event) {
        $mdDialog.show({
            controller: "ElectronicDownloadAccessLogCtrl",
            controllerAs: "electronicDownloadAccessLogCtrl",
            targetEvent: event,
            templateUrl: "modules/electronicdownload/templates/electronicdownloadaccesslog.tmpl.html",
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                eddId: selectedListItems.getFirstSelectedId()
            }
        })
    };

    self.deleteDownloadArticle = function (event, trns) {
        ConfirmationService.showConfirmationDialog(deleteDownloadRequest, event, trns.delete + '?', trns.delete, trns.abort, trns.deleteQuestion);
    };

    self.buttonDefinition = [{
        label: "reset",
        action: self.resetDownloadCounter,
        condition: canResetDownloadCounter,
        process: 'ElectronicDownloadReset'
    }, {
        label: "accessLog",
        action: self.showAccessLog,
        condition: selectedListItems.isSingleSelection,
        process: 'ElectronicDownloadAdmin'
    }, {
        label: "delete",
        action: self.deleteDownloadArticle,
        condition: selectedListItems.isSingleSelection,
        process: 'ElectronicDownloadAdmin'
    }];

    self.meta = {
        rowTemplate: 'modules/electronicdownload/templates/electronicdownloadadmin-list.row.tmpl.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/electronicdownload/admin/list',
        id: "electronicdownloadadmin",
        buttonDefinition: self.buttonDefinition
    };

    self.getMeta = function () {
        return self.meta;
    };

    function canResetDownloadCounter() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canReset;
    }

    function refreshList() {
        ListHelperService.refreshListData($scope, 'electronicDownloadAdminCtrl', {unselectRow: selectedListItems.getFirstSelectedItem()});
    }

    function deleteDownloadRequest() {
        dataGen.postAsForm({}, {eddId: selectedListItems.getFirstSelectedId()}, "/electronicdownload/delete").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            refreshList();
        });
    }
}